<p-dialog header="Billing Information" [(visible)]="display" [modal]="true" [style]="{width: '640px'}" [minY]="70" appendTo="body"
  [baseZIndex]="10000" [closable]="false" [maximizable]="false" [blockScroll]="true" class="billing-dialog"
  >
  <app-billing-profile-entry [stripeBilling]="stripeBilling" [customer]="customer" (emitUpdatedStripeCustomerId)="afterSave($event)" (emitClose)="cancel()"></app-billing-profile-entry>
  <div class="button-group" style="float: right">
    @if (!isCustomer) {
      <p-button type="button" severity="warn" label="Cancel" style="margin-right: 5px;"
        (click)="cancel()">
      </p-button>
    }
    <p-button type="submit" severity="success"   label="Save"
      (click)="save()">
    </p-button>
  </div>
</p-dialog>